import { jsonPost } from "@/utils/request";

export async function getListByBatchNoAPI(params) {
  let res = await jsonPost({
    url: `/spotfreight/createTask`,
    params
  });
  return res;
}

export async function  generateBatchNoAPI(params) {
  let res = await jsonPost({
    url: `/spotfreight/generateBatchNo`,
    params
  });
  return res;
}

export async function getStatusAPI(params) {
  let res = await jsonPost({
    url: `/spotfreight/getBatchNoStatus`,
    params
  });
  return res;
}

